module.exports = __webpack_public_path__ + "img/27.49c639a8.jpg";